module.exports = __webpack_public_path__ + "static/media/MIMATIC-USDC.f0796b58.png";